import { Sparkle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MarqueeProps {
  items: string[];
  className?: string;
  fast?: boolean;
}

/** Infinite ribbon. Content is duplicated so the -50% loop is seamless. */
export function Marquee({ items, className, fast = false }: MarqueeProps) {
  const row = [...items, ...items];

  return (
    <div className={cn('marquee-mask overflow-hidden py-4', className)}>
      <div
        className={cn(
          'flex w-max items-center gap-10 whitespace-nowrap',
          fast ? 'animate-marquee-fast' : 'animate-marquee',
        )}
      >
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10" aria-hidden={i >= items.length}>
            <span className="font-display text-sm font-semibold uppercase tracking-[0.25em] md:text-base">
              {item}
            </span>
            <Sparkle className="size-4 shrink-0" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
